import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder"
import {  ShoppingBasket } from "lucide-react"
import { Link } from "react-router-dom"
import { RewardItemData } from "@/common/types/rewardItems"
import { rewardItemsStatusStrategy } from "../../constants/rewardItemsStatusOptions.constant"
import { formatDate } from "@/common/utils/formatters"

interface RewardItemsGridItemProps {
  rewardItem: RewardItemData
}

export const RewardItemsGridItem = ({ rewardItem }: RewardItemsGridItemProps) => {
  return (
    <Link to={`/tmais-reward-items/${rewardItem.id}`} className="flex flex-col bg-white-200 rounded-lg overflow-hidden">
      <ImageWithPlaceholder
        url={rewardItem?.pictures?.length ? rewardItem.pictures[0]?.url : undefined}
        alt={rewardItem.display_name}
        placeholderIcon={ShoppingBasket}
        className="w-full size-auto rounded-none bg-white-800 aspect-[4/3]"
        iconClassName="size-32"
      />

      <div className="w-full space-y-2 text-white-800 p-4">
        <p>{rewardItem.display_name}</p>
        <div className="flex items-center gap-2">
          <div className="flex flex-col">
            <span className="text-xs italic font-light">Status</span>
            <p className="text-sm font-bold">{rewardItemsStatusStrategy[rewardItem.status as keyof typeof rewardItemsStatusStrategy]}</p>
          </div>
          <div className="flex flex-col">
            <span className="text-xs italic font-light">Expira em</span>
            <p className="text-sm font-bold">{rewardItem.available_until ? formatDate(new Date(rewardItem.available_until)) : '--'}</p>
          </div>
        </div>
        <div className="flex flex-col">
          <span className="text-xs italic font-light">Descrição</span>
          <p className="text-sm font-bold line-clamp-2">{rewardItem.description}</p>
        </div>
      </div>
    </Link>
  )
}
